<!-- 符合性声明 form 组件 -->
<template>
  <h-inspection-page :title="h_i18n('3fe23c87907c4bdfcd5b54f4ddc66360')+data.title" @inspection-update="inspectionUpdate" class="ComponentConformityDeclarations_style">
    <form-header :title="h_i18n('3fe23c87907c4bdfcd5b54f4ddc66360')+data.title" title-height="80px" class="top_wrap_style">

      <template #body>
        <tr>
          <report-td :title="h_i18n('1b7ecd2bdbd8a1a112dead57724f06df')" colspan="4:8">{{ getData.supplyCode }}</report-td>
          <report-td :title="h_i18n('9190cc22c9ba377113bc54ac51013a0b')" colspan="4:8">{{ getData.supplyName }}</report-td>
        </tr>
        <tr>
          <report-td v-if="kindType == 'sqmModify'" :title="h_i18n('2a56aa49c7068741c8fc1d1de4acbe51')" colspan="4:8" style="position: relative;" required>
            <el-input disabled v-model="postData.mtlNo"></el-input>
          </report-td>
          <report-td v-if="kindType == 'sqmAdd'" :title="h_i18n('2a56aa49c7068741c8fc1d1de4acbe51')" colspan="4:8" style="position: relative;" required>
            <el-tooltip effect="redTip" placement="top-start" :disabled="false" :visible="tipFlag.mtlNo"
                :content="h_i18n('a285ac233adee3b770dd0b2c27354eaf')">
                <div></div>
              </el-tooltip>
              <h-autocomplete popper-class="planHidden" v-model="postData.mtlNo" :fetch-suggestions="mtlNoChange" class="mtlNo_input_style"
              :trigger-on-focus="false" @input="() =>
                  postData.mtlNo.length < 4 ? (plan.showMtlPlan = false) : ''"
                  @clear="plan.showMtlPlan = false , postData.mtlName = ''" clearable :placeholder="h_i18n('590d740e9c23636cb1f43b9d162c3ede')" @blur="detailBlur('showMtlPlan')"
                  @focus="detailFocus('showMtlPlan')">
              </h-autocomplete>
              <h-detail width="450px" top="245px" left="20%">
                <el-table v-show="plan.showMtlPlan" v-loading="data.mtlLoading" :data="data.mtlNoList" border size="small"
                  max-height="252" @row-click="clickMtlNo" @mousedown="plan.planBlur = true">
                  <el-table-column prop="mtlNo" :label="h_i18n('f1edca9f040d256cee01ef89fa5499f0')" width="120"></el-table-column>
                  <el-table-column prop="mtlName" :label="h_i18n('901fcadda8a5683e7a83a0c811ff4382')"></el-table-column>
                </el-table>
                <div v-if="plan.showMtlPlan && plan.MtlOver600" style="color: red;height: 20px;background-color: #fff;
                    padding-top: 3px;">
                  <span style="padding-left: 10px; font-size: 12px">{{ h_i18n('fb36f45f54ec9c9de745b566c6e60e25') }}</span>
                </div>
              </h-detail>
          </report-td>

          <report-td v-if="kindType == 'sqmDetail' || kindType == 'hmqmDetail'" :title="h_i18n('2a56aa49c7068741c8fc1d1de4acbe51')" colspan="4:8" style="position: relative;">
            {{ getData.mtlNo }}
          </report-td>

          <report-td :title="h_i18n('901fcadda8a5683e7a83a0c811ff4382')" colspan="4:8" v-if="kindType == 'sqmAdd' || kindType == 'sqmModify'" required>
            <el-tooltip effect="redTip" placement="top-start" :disabled="false" :visible="tipFlag.mtlName"
                :content="h_i18n('3fa530780baa7ca2cf7d7ace341d41dc')">
                <div></div>
              </el-tooltip>
            <el-input disabled :placeholder="h_i18n('db4c75ff2e2f1246a6d344b43fc04176')" v-model="postData.mtlName"></el-input>
          </report-td>
          <report-td :title="h_i18n('901fcadda8a5683e7a83a0c811ff4382')" colspan="4:8" v-if="kindType == 'sqmDetail' || kindType == 'hmqmDetail'">
            {{ getData.mtlName }}
          </report-td>
        </tr>
        <tr>
          <report-td v-if="kindType == 'sqmAdd' || kindType == 'sqmModify'" :title="h_i18n('261aef771e0245a077599b5ca686c499')" colspan="4:8" blueTitleTip frontQuestion required>
            <template #tipText>{{ h_i18n('43b96b815c5fe334f51cbc1fe8dfe74d') }}</template>
            <el-tooltip effect="redTip" placement="top-start" :disabled="false" :visible="tipFlag.relateStandard"
                :content="h_i18n('96db1d224b7b0e84b63a820f1165873d')">
                <div></div>
              </el-tooltip>
            <el-radio-group v-model="postData.relateStandard">
              <el-radio label="Q/HR0603001">Q/HR0603001</el-radio>
              <el-radio label="Q/HR0603003">Q/HR0603003</el-radio>
            </el-radio-group>
          </report-td>

          <report-td :title="h_i18n('261aef771e0245a077599b5ca686c499')" colspan="4:8" v-if="kindType == 'sqmDetail' || kindType == 'hmqmDetail'">
            {{ getData.relateStandard }}
          </report-td>

          <report-td v-if="kindType == 'sqmAdd' || kindType == 'sqmModify'" :title="h_i18n('1b9b4711fd9584e570c22e0d2ae70b0b')" colspan="4:8" :blueTitleTip="kindType == 'sqmModify'" :frontQuestion="kindType == 'sqmModify'">
            <template v-if="kindType == 'sqmModify'" #tipText>{{ h_i18n('16f940b5376dbfaa8b83be375a7d800a') }}</template>
            <el-select v-model="postData.relateMtlNo" multiple @change="relateMtlNoChange" filterable remote
              :remote-method="relateMtlNoRemote" :loading="data.relateMtlNoLoading" :placeholder="h_i18n('590d740e9c23636cb1f43b9d162c3ede')">
              <el-option v-for="item in data.relateMtlNoList" :key="item.relateMtlNo" :label="item.relateMtlNo" :value="item.relateMtlNo">
                <span style="float: left">{{ item.relateMtlNo }}</span>
                <span>&nbsp;</span>
                <span style="float: right">{{ item.relateMtlName }}</span>
              </el-option>
            </el-select>
            <!-- <h-autocomplete popper-class="planHidden" v-model="postData.mtlNo" :fetch-suggestions="mtlNoChange" multiple
              :trigger-on-focus="false" @input="() =>
                  postData.mtlNo.length < 8 ? (plan.showMtlPlan = false) : ''" 
                  @clear="plan.showMtlPlan = false , postData.mtlName = ''" clearable placeholder="请输入不少于八位进行模糊查询" @blur="detailBlur('showMtlPlan')"
                  @focus="detailFocus('showMtlPlan')">
              </h-autocomplete>
              <h-detail width="400px" top="245px" left="20%">
                <el-table v-show="plan.showMtlPlan" v-loading="data.mtlLoading" :data="data.mtlNoList" border size="small"
                  max-height="252" @row-click="clickMtlNo" @mousedown="plan.planBlur = true">
                  <el-table-column prop="mtlNo" label="专用号" width="120"></el-table-column>
                  <el-table-column prop="mtlName" label="物料名称"></el-table-column>
                </el-table>
              </h-detail> -->
          </report-td>

          <report-td :title="h_i18n('1b9b4711fd9584e570c22e0d2ae70b0b')" colspan="4:8" v-if="kindType == 'sqmDetail' || kindType == 'hmqmDetail'">
            {{ getData.relateMtlNo }}
          </report-td>
        </tr>
        <tr>
          <report-td v-if="kindType == 'sqmAdd' || kindType == 'sqmModify'" :title="h_i18n('065f4fe3485e8818bb64206abd0d2f5a')" colspan="4:8" required>
            <el-tooltip effect="redTip" placement="top-start" :disabled="false" :visible="tipFlag.supplyFactory"
                :content="h_i18n('e804d34ad855fce4ec3a73d9cd4331d7')">
                <div></div>
              </el-tooltip>
            <el-select v-model="postData.supplyFactory" clearable filterable multiple
              @change="changeNull(postData.supplyFactoryCode, 'supplyFactoryCode'), sybIdChange($event)">
              <template v-for="item in data.supplyFactoryList" :key="item.valueId">
                <el-option :label="item.valueName" :value="item.valueName"></el-option>
              </template>
            </el-select>
          </report-td>
          <report-td :title="h_i18n('065f4fe3485e8818bb64206abd0d2f5a')" colspan="4:8" v-if="kindType == 'sqmDetail' || kindType == 'hmqmDetail'">
            {{ getData.supplyFactoryName }}
          </report-td>

          <report-td v-if="kindType == 'sqmAdd' || kindType == 'sqmModify'" :title="h_i18n('c9a6ee90f5d43732e3f6cf4dcaa8493c')" colspan="4:8" blueTitleTip frontQuestion required>
            <template #tipText>{{ h_i18n('0f3aea21e2c35774cd749f83fd968187') }}</template>
            <el-tooltip effect="redTip" placement="top-start" :disabled="false" :visible="tipFlag.fileUuid"
                :content="h_i18n('506ca53a3365fd9217ba87b4347a1636')">
                <div></div>
              </el-tooltip>
            <h-file v-if="postData.fileUuid && postData.fileName" :name="postData.fileName" :delete-type="true" :url="postData.fileUuid" @delete="deleteFun"
              :autoOpen='false' @open="openFile(getData.fileUuid || postData.fileUuid,getData.fileName || postData.fileName)"></h-file>
            <h-button v-else @click="data.fileChoose = true" type="primary">{{ h_i18n('0063c51e228e58fddadbff82a79cf3c0') }}</h-button>
          </report-td>

          <report-td :title="h_i18n('c9a6ee90f5d43732e3f6cf4dcaa8493c')" colspan="4:8" v-if="kindType == 'sqmDetail' || kindType == 'hmqmDetail'">
            <h-file v-if="getData.fileUuid && getData.fileName" :name="getData.fileName" :delete-type="false" :url="getData.fileUuid" @delete="deleteFun"
             :autoOpen='false' @open="openFile(getData.fileUuid,getData.fileName)"></h-file>
          </report-td>

        </tr>
        <tr v-if="kindType == 'sqmDetail'">
          <report-td :title="h_i18n('0039880117c13787732d259f5bc9f7f5')" colspan="4:8">
            {{ time(getData.isrtDate,6) }}
          </report-td>
          <report-td :title="h_i18n('a001a226fdc34fd7121f9c4839c759a2')" colspan="4:8">
            {{ time(getData.updateTime,6) }}
          </report-td>
        </tr>
        <tr v-if="kindType == 'sqmDetail' || kindType == 'sqmAdd' || kindType == 'sqmModify'">
          <report-td :title="h_i18n('1bbbb204023e59eba03319c7c5848fd1')" colspan="4:20">
            <span style="display:block;color:red;">{{ h_i18n('c228279b5256338a5516bea4c3b02088') }}</span>
            <span style="color:red;display:block;white-space: normal;">{{ h_i18n('8ddab98d19d75c816532f4bcc1086677') }}</span>
          </report-td>
        </tr>
        <tr v-if="kindType == 'hmqmDetail'">
          <report-td :title="h_i18n('ae27d6f465386eb63210704c8918c6c4')" colspan="4:8">
            {{ getData.isrtEmpName }}
          </report-td>
          <report-td :title="h_i18n('d5d8573dbbc6c2925ebd391ae506dc18')" colspan="4:8">
            {{ time(getData.isrtDate,6) }}
          </report-td>
        </tr>
      </template>
      <div style="padding:20px 0">
        <h-button-group align="center">
          <h-button type="primary" size="small" :loading="subLoading" @click="submit" v-if="kindType == 'sqmAdd' || kindType == 'sqmModify'">{{ h_i18n('939d5345ad4345dbaabe14798f6ac0f1') }}</h-button>
          <h-button type="default" size="small" @click="back">{{ h_i18n('5f411223ca5a01a5adf20fe735a433d0') }}</h-button>
        </h-button-group>
      </div>
    </form-header>
    
    <h-dialog class="over_dialog_style" :show="data.fileChoose" :title="h_i18n('481e034e6026969aae4ce7ce7c8a7b6f')" footer @close="data.fileChoose = false"
        width="900px">
        <el-row>
          <div style="color:red;font-size:14px;height:28px;line-height:28px;padding-left: 28px;">{{ h_i18n('5cd3736775ec126a64e902eaff487e7b') }}</div>
        </el-row>
        <el-row>
          <div style="color:red;font-size:14px;height:28px;line-height:28px;padding-left: 28px;">{{ h_i18n('0c72b57c85c26a7f2f8d863577c63ec9') }}</div>
        </el-row>
        <el-row>
          <div style="color:red;font-size:14px;height:28px;line-height:28px;padding-left: 28px;">{{ h_i18n('abc3f82e3dd428decc61fd738fdb913d') }}</div>
        </el-row>
        <el-row>
          <div style="color:red;font-size:14px;height:28px;line-height:28px;padding-left: 28px;">{{ h_i18n('626f03eea2bec1c099651204621ff494') }}</div>
        </el-row>
        <el-row>
          <div style="color:red;font-size:14px;height:28px;line-height:28px;padding-left: 28px;">{{ h_i18n('3dc1bbaffb3e2b25b326a0284ce89564') }}</div>
        </el-row>
        <el-row>
          <div style="font-size:14px;height:28px;line-height:28px;padding: 20px 0 20px 28px">
            <span style="font-weight:600">{{ h_i18n('2bc21499c9adb3d1470d91b7f7bc7351') }}</span> 
            <span style="text-align: left; color:#2681ff;cursor:pointer;" @click="downF('Q/HR0603001')">Q/HR0603001_中文</span>
            <span>&nbsp;&nbsp;&nbsp;</span>
            <span style="text-align: left; color:#2681ff;cursor:pointer;" @click="downF('Q/HR0603003')">Q/HR0603003_中文</span>
            <span>&nbsp;&nbsp;&nbsp;</span>
            <span style="text-align: left; color:#2681ff;cursor:pointer;" @click="downF('Q/HR0603001_English')">Q/HR0603001_English</span>
            <span>&nbsp;&nbsp;&nbsp;</span>
            <span style="text-align: left; color:#2681ff;cursor:pointer;" @click="downF('Q/HR0603003_English')">Q/HR0603003_English</span>
          </div>
        </el-row>
        <el-row>
          <hc-file-upload download delete v-model="data.fileTemp"
                acceptOther="jpg,jpeg,png,pdf" accept="other" size="30" :disabled="data.d5"
                :info="h_i18n('28f6f5a5f0cd6e37a861e06b2a8cccac')" @error="errorFile"
                @delete="deleteFun" @download="download" @change="fileChange">
              </hc-file-upload>
        </el-row>
    </h-dialog>

  </h-inspection-page>
</template>




<script setup>
//Automatic script writing.
import h_i18n from '@/utils/Internationalization';

  import {reactive,getCurrentInstance,onMounted, onBeforeMount, nextTick, onUpdated, ref, defineEmit, computed} from "vue";
  import { useRoute } from "vue-router";
  import axios from "axios";
  const { proxy, ctx } = getCurrentInstance();
  const route = useRoute();
  const emit = defineEmit(
    ['submitBtn','backBtn']
  )
  const tipFlag = reactive({
    mtlNo:false,
    mtlName:false,
    relateStandard:false,
    relateMtlNo:false,
    supplyFactory:false,
    fileUuid:false,
  })
  const props = defineProps({
    kindType: {
      type: String,
      default: ''
    },
    getData: {
      type:Object,
      default: {}
    },
    subLoading: {
      type: Boolean,
      default: false
    }
  })
  const data = reactive({
    title:'',
    supplyFactoryList: [], //供货工厂
    fileTemp:{},
    fileChoose:false,
    isSelect:false,
    lastChangeValue:[],// 上一次选择的 材料组成相同的关联专用号
  })
  const postData  =reactive({
    mtlNo:'',
    relateStandard:"Q/HR0603001"
  })

  /**
 * 传高度
 */
const changeMethod = () => {
  proxy.postThisPageHeight();
};
const inspectionUpdate = () => {
  proxy.postThisPageHeight();
}

  const submit = () => {
    if(!postData.supplyCode || !postData.supplyName){
      proxy.warning(h_i18n('d26e7275f9cd553afc85b43d5cc99f45'))
      return
    }
  if (!postData.mtlNo) {
    tipFlag.mtlNo = true
    setTimeout(() => {
      tipFlag.mtlNo = false
    }, 2000);
    return
  }
  if (!postData.mtlName) {
    tipFlag.mtlName = true
    setTimeout(() => {
      tipFlag.mtlName = false
    }, 2000);
    return
  }
  
  if (!postData.relateStandard) {
    tipFlag.relateStandard = true
    setTimeout(() => {
      tipFlag.relateStandard = false
    }, 2000);
    return
  }
  if(postData.relateMtlNo && postData.relateMtlNo?.join()?.length > 40000){
    proxy.info(h_i18n('1C0090B0B63EE50F59E051B914EF4F95'))
    return
  }
  if (!postData.supplyFactoryCode || postData.supplyFactoryCode.length == 0) {
    tipFlag.supplyFactory = true
    setTimeout(() => {
      tipFlag.supplyFactory = false
    }, 2000);
    return
  }
  if (!postData.fileUuid) {
    tipFlag.fileUuid = true
    setTimeout(() => {
      tipFlag.fileUuid = false
    }, 2000);
    return
  }
  // 企标变化了 需要查询接口
  if(postData.relateStandard != props.getData.relateStandard){
    proxy.$http({
      url:'/base/rohs/validateUpdateConformityDeclarations',
      method:'post',
      data:{
        mtlNo: postData.mtlNo,
        relateStandard: postData.relateStandard,
        supplyCode: props.getData.supplyCode
      }
    }).then(res=>{
      if (res.data.code == "500") {
        proxy.info(h_i18n('88360d515e15c9d65fec9f5c54e168be')+postData.relateStandard+h_i18n('873ccfa359be9006222992b68e751d17'))
      }else if(res.data.code == '0'){
        emit('submitBtn',postData)
      }
    })
  }else{
    emit('submitBtn',postData)
  }
  
  }
  const back = () => {
    emit("backBtn")
  }

  // 两个模糊查询相关
  const http = reactive({
    mtlSearchHttp: false,
    supplySearchHttp: false,
  });
  const plan = reactive({
    showMtlPlan: false,
    planBlur: false,
    MtlOver600: false,
    SupplyOver600: false,
    showSupplyPlan: false,
  });

  // 弹窗失焦
  const detailBlur = (v) => {
    if (!plan.planBlur) {
      plan[v] = false;
    }
    if(postData.mtlNo){
      setTimeout(() => {
        if(!data.isSelect){
          if(postData.mtlNo.length < 4){
            proxy.$message({
              message: h_i18n('82cf9fc7681ec05069e43a426038b1ec'),
              type: 'warning',
            })
            postData.mtlNo = ''
          }else{
            proxy.$message({
              message: h_i18n('e438042cf0eee10d7843c9be1ac6665f'),
              type: 'warning',
            })
            postData.mtlNo = ''
          }
        }
      }, 500);
    }
  };
  // 弹窗聚焦
  const detailFocus = (v) => {
    plan.planBlur = false;
    if (v == "showSupplyPlan") {
      if (postData.supplyCode.length >= 2) {
        plan[v] = true;
      }
    } else if (v == "showMtlPlan") {
      if (postData.mtlNo.length >= 4) {
        plan[v] = true;
      }
    }
  };
  const clickMtlNo = (row) => {
    postData.mtlNo = row.mtlNo;
    data.isSelect = true
    proxy.$http({
      url:'/base/rohs/findMtlNo?mtlNo='+row.mtlNo+'&supplyCode='+props.getData.supplyCode+'&relateStandard='+postData.relateStandard,
      method:'get',
    }).then(res=>{
      console.log(res)
      if(res.data.data == false){
        postData.mtlName = row.mtlName
        plan.showMtlPlan = false;
        setTimeout(() => {
          data.isSelect = false
        }, 1000);
        // 可以添加
      }else{
        proxy.info(h_i18n('3d315a0384ec4acc118a104480c10f75'))
        postData.mtlNo = ''
        setTimeout(() => {
          data.isSelect = false
        }, 1000);
      }
    })
  };
  const clickSupplierCode = (row) => {
    postData.supplyCode = row.supplyCode;
    plan.showSupplyPlan = false;
  };
  /**
   * 专用号模糊查询
   */
  const mtlNoChange = (v) => {
    
    plan.planBlur = false;
    if (http.mtlSearchHttp) http.mtlSearchHttp.cancel();
    http.mtlSearchHttp = axios.CancelToken.source();
    if (postData.mtlNo.length < 4) {
      plan.showMtlPlan = false;
    } else {
      plan.showMtlPlan = true;
      data.mtlLoading = true;
      proxy
        .$http({
          method: "POST",
          url: "/base/baseMateriel/selectMtlNo",
          headers: { "content-type": "application/json" },
          data: {
            fixConfig:true,
            mtlNo: postData.mtlNo,
            supplyCode: props.getData.supplyCode,
          },
          cancelToken: http.mtlSearchHttp.token,
        })
        .then((res) => {
          data.mtlNoList = res.data.data;
          if (data.mtlNoList.length >= 600) {
            plan.MtlOver600 = true;
            data.mtlLoading = false;
          } else {
            plan.MtlOver600 = false;
            data.mtlLoading = false;
          }
        })
        .catch((e) => { });
    }
  }
  // 两个模糊查询结束
  /* 
  * 模糊查询 关联专用号
  * url: 'api/changeManage/searchMtlNo',
  * "mtlNo" : mtlNo ,
  */
  const relateMtlNoRemote = (v) => {
    if(v && v.length >= 4){
      // console.log(v)
      data.relateMtlNoLoading = true
      proxy
        .$http({
          method: "POST",
          url: "/base/baseMateriel/selectMtlNo",
          headers: { "content-type": "application/json" },
          data: {
            mtlNo: v,
            fixConfig:true,
          },
        })
        .then((res) => {
          data.relateMtlNoList = res.data.data.map(item=>{
            return {relateMtlNo:item.mtlNo,relateMtlName:item.mtlName}
          });
          data.relateMtlNoLoading = false;
        })
        .catch((e) => { });
    }
  }
  const relateMtlNoChange = (v) => {
    if(!postData.mtlNo){
      proxy.info(h_i18n('038ab5ae486746b822d01fd7bfc65a3e'))
      postData.relateMtlNo.splice(0,1)
      return
    }
    if(!postData.relateStandard){
      proxy.info(h_i18n('a3dc26c2b768c5f447d7f885b67f58d8'))
      postData.relateMtlNo.splice(0,1)
      return
    }
    let i = -1
    if(v.some((item,index)=>{
      if(postData.mtlNo == item){
        i = index
       return true
      }
    })){
      proxy.info(h_i18n('47eb473ecc8a54b7becc1200b9cba2ca'))
      postData.relateMtlNo.splice(i,1)
      return
    }
    // 总长度 40000
    if(v?.join()?.length > 40000){
      proxy.info(h_i18n('1C0090B0B63EE50F59E051B914EF4F95'))
      return
    }
    console.log(v)
    // 找到本次新增的 查询是否可用
    let findMtl = v[v.length-1]
    // let findMtl = v.find(item=>{
    //   return !data.lastChangeValue.includes(item)
    // })
    if(findMtl){
      proxy.$http({
        url:'/base/rohs/findMtlNo?mtlNo='+findMtl+'&supplyCode='+props.getData.supplyCode+'&relateStandard='+postData.relateStandard,
        method:'get',
        async:false,
      }).then(res=>{
        console.log(res)
        if(res.data.data == false){
          // 可以添加
        }else{
          proxy.info(h_i18n('ae6c2f49100d90869604ee4af29e7f0d')+findMtl+h_i18n('873ccfa359be9006222992b68e751d17'))
          // postData.relateMtlNo.splice(v.indexOf(findMtl),1)
          // postData.relateMtlNo = []
          data.relateMtlNoList = []
          setTimeout(() => {
            let tempList = postData.relateMtlNo.filter(item=>item != findMtl)
            console.log(tempList)
            postData.relateMtlNo = []
            postData.relateMtlNo = tempList
          }, 10);
          return
        }
      }).catch(err=>{

      }).finally(()=>{
        data.lastChangeValue = postData.relateMtlNo
      })
    }else{
      data.lastChangeValue = v
    }
    // console.log(data.lastChangeValue)
    // console.log(postData.relateMtlNo)
  }
  // input为空时undefined
  const changeNull = (value, key) => {
    if (value === "") {
      postData[key] = undefined;
    }
  };
  // 获取 供货工厂
  const getSupplyFactoryList = () => {
    proxy
      .$http({
        method: "POST",
        url: "/base/rohs/searchFactoryInfoFromHMQM",
        // api/rohs/searchFactoryInfoFromHMQM 老接口
        headers: { "content-type": "application/json" },
        data: {
          fixConfig:true,
          supplyCode:props.getData.supplyCode
        },
      })
      .then((res) => {
        if (res.data.code == 0) {
          data.supplyFactoryList = res.data.data.map(item => {
            return { valueId: item.supplyFactoryCode, valueName: item.supplyFactoryName }
          })
        } else {
          data.supplyFactoryList = []
        }
      }).catch(err => {
        data.supplyFactoryList = []
        // console.log(err)
      })
  };
  // 选择 供货工厂
  const sybIdChange = (v) => {
    postData.supplyFactoryName = v
    console.log('data.supplyFactoryList',data.supplyFactoryList)
    postData.supplyFactoryCode = v.map(item=>{
      return data.supplyFactoryList.find(temp => temp.valueName === item)?.valueId
    })
    console.log('postData.supplyFactoryName',postData.supplyFactoryName)
    console.log('postData.supplyFactoryCode',postData.supplyFactoryCode)
    // postData.supplyFactoryItem = v.map(item=>{ // keyvalue形式 应该没用
    //   return data.supplyFactoryList.find(temp => temp.valueName == item)
    // })
    // console.log('供货工厂',postData.supplyFactoryItem)
    // console.log(postData.supplyFactoryCode,postData.supplyFactoryName)
  };

  /**
 * 错误提示
 */
 const errorFile = (str) => {
  proxy.warning({title: h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'), message: str})
}

// 支持老附件下载
const openFile = (uuid,name) => {
  console.log(uuid,name)
  proxy.startLoading(h_i18n('29f986479f7cf1f93d31172f343d4521'))
  // https://sqm.haier.net/downLoadFileNew?type=5&fileUUID=2024/02/03/284771ef-a758-434c-bf22-157de2839076.jpg
  let url = ''
  if(uuid.includes('http')){
    // url = "/tosqmfordown/"+uuid.split('https://sqm.haier.net/')[1]
    url = "/base/fileDownload/downloadFile?filePath="+uuid.split('https://sqm.haier.net/readFile/')[1]
  }else{
    // let uid = process.env.NODE_ENV === "production" ? "http://sqm.haier.net/" :  "http://sqm-test.qd-huangdao-test.haier.net/"
    // let uid = process.env.NODE_ENV === "production" ? "https://sqm.haier.net/" :  "http://sqm-test.qd-huangdao-test.haier.net/"
    url = '/base/fileDownload/downLoadFileFtp?type=5&fileUUID='+uuid
  }
  // proxy.startLoading('下载中...')
  proxy.httpFile({
    method: "get",
    url: url,
    headers: {'content-type': 'application/json'},
  }, name)
}

/**
 * h-file-upload 上传文件
 */
const fileChange = (file,f) => {
  
    postData.fileName = file.name
    
    let formData = new FormData()
    formData.append('files', file.file)
    proxy.startLoading(h_i18n('92cd554eff7896f979917f3ae449b460'))
    proxy.$http({
      method: "POST",
      url: "/base/fileUpload/uploadToOssSaveUrl",
      data: formData
    }).then(res => {
      if (res.data.code === "0") {
        postData.fileUuid = res.data.data
        data.fileChoose = false
      } else {
        proxy.error(h_i18n('3a845c4dd82bd5a445333dfcbabb4350'))
        data.fileTemp = null
      }
    }).catch(err=>{

    }).finally(()=>{
      proxy.closeLoading()
    })
  
}
/**
 * h-file-upload 下载
 */
const download = () =>{
  
    proxy.startLoading(h_i18n('29f986479f7cf1f93d31172f343d4521'))
    proxy.httpFile({
      method: "get",
      // url: "/tosqmfordown/"+postData.fileUuid.split('https://sqm.haier.net/')[1],
      url: "/base/fileDownload/downloadFile?filePath="+postData.fileUuid.split('https://sqm.haier.net/readFile/')[1],
      headers: {'content-type': 'application/json'},
    }, postData.fileName)
}

/**
 * h-file-upload 删除
 */
const deleteFun = () =>{
    postData.fileUuid = ''
    postData.fileName = ''
    data.fileTemp = {}  
}
// 模板下载
const downF = (v) => {
  // v == 'Q/HR0603003' && window.open('http://sqm-test.qd-huangdao-test.haier.net/downLoadFileNew?type=5&fileUUID=standardTemplet/QHR0603003.docx')
  // v == 'Q/HR0603001' && window.open('http://sqm-test.qd-huangdao-test.haier.net/downLoadFileNew?type=5&fileUUID=standardTemplet/QHR0603001.docx')
  v == 'Q/HR0603003' && openDown('?type=5&fileUUID=standardTemplet/QHR0603003.docx','QHR0603003.docx')
  v == 'Q/HR0603001' && openDown('?type=5&fileUUID=standardTemplet/QHR0603001.docx','QHR0603001.docx')
  v === 'Q/HR0603001_English' && openNewDown('/basicInfo/QHR0603001Compliance Statement - English.docx',v+'.docx')
  v === 'Q/HR0603003_English' && openNewDown('/basicInfo/QHR0603003-Compliance Statement - English.docx',v+'.docx')
}
// 解决 无法安全下载
const openDown = (url,fileTitle) => {
  console.log('================url,fileTitle',url,fileTitle)
  proxy.startLoading()
  proxy.httpFile({
    method: 'get',
    url:'/base/fileDownload/downLoadFileFtp'+url,
    headers: { 'content-type': 'application/json' }
  },fileTitle)
  // proxy.httpFileNew(url,fileTitle)
}
const openNewDown = (url,fileTitle) => {
  proxy.startLoading()
  proxy.httpFile({
    method: 'get',
    url:'/base/fileDownload/downloadFile?filePath=' + url,
    headers: { 'content-type': 'application/json' }
  },fileTitle)
}
onBeforeMount(()=>{
  props.kindType == 'sqmAdd' && (data.title = h_i18n('491411e0ae5d09d5eca25a2b2f275e3b'))
  props.kindType == 'sqmModify' && (data.title = h_i18n('8347a927c09a4ec2fe473b0a93f667d0'))
  props.kindType == 'sqmDetail' && (data.title = h_i18n('f82e511ce6bdd31025bb4f9f8b5cb43a'))
  props.kindType == 'hmqmDetail' && (data.title = h_i18n('f82e511ce6bdd31025bb4f9f8b5cb43a'))
  postData.supplyCode = props.getData.supplyCode
  postData.supplyName = props.getData.supplyName
  getSupplyFactoryList()
})

onMounted(()=>{
  // console.log(props.getData)
  if(props.kindType == 'sqmModify'){
    postData.mtlNo = props.getData.mtlNo
    postData.mtlName = props.getData.mtlName
    postData.relateStandard = props.getData.relateStandard
    postData.relateMtlNo = props.getData.relateMtlNo ? props.getData.relateMtlNo.split(',') : ""
    postData.supplyFactoryCode = props.getData.supplyFactoryCode
    postData.supplyFactoryName = props.getData.supplyFactoryName
    postData.supplyFactory = props.getData.supplyFactoryName.split(',')
    postData.fileUuid = props.getData.fileUuid
    postData.fileName = props.getData.fileName
  }
})
</script>

<style scoped lang="scss">
:deep(.mtlNo_input_style){
  div{
    input{
      padding-left: 15px;
    }
  }
}
.top_wrap_style{
  padding-left: 0px;
  padding-right: 0px;
}
.ComponentConformityDeclarations_style{
  .over_dialog_style{
    .el-row{
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
    .el-row:hover{
      overflow: auto;
    }
   }
}
</style>

<style>
.planHidden{
  display: none;
}
</style>